module.exports = {
	BASE_URL: "https://api.staging.sharechat.com",
	RECAPTCHA_SITE_KEY: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
};
